<div class="container-fluid ac-poppins mt-4">
    <div class="row form-head mb-4">
        <div class="mb-3">
        <a [routerLink]="['../summary']" class="ac-goback-btn" >
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
                <path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z"/>
            </svg>
        Go Back </a>
        </div>
        <div class="me-auto d-sm-flex" style="align-items: center;display: -webkit-inline-box;">
            <h2 class="text-black font-w600 mb-0 ac-inv-no">Checkout</h2>
        </div>
    </div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card">
                <div class="card-body">
                    <div class="row mobile-view-change">
                        <div class="col-lg-6 col-md-6 order-md-1 mb-4">
                            <app-speedpay-payment *ngIf="!isNewPaymentExperienceEnable" [data]="{ban}"></app-speedpay-payment>
                            <app-payment-flow *ngIf="isNewPaymentExperienceEnable"></app-payment-flow>
                        </div>
                        <div class="col-lg-6 col-md-6 order-md-2 mt-32">
                            <ul class="list-group mb-3" *ngIf="!historicalInvoicePymtIndicator">
                                <li class="list-group-item d-flex justify-content-between lh-condensed"
                                    *ngFor="let data of invoiceList;let i = index">
                                    <div>
                                        <p class="my-0 fs-16 text-black font-w600">Invoice Number</p>
                                        <small class="fs-16">{{data.invoice_id}}</small>
                                    </div>
                                    <div>
                                        <p class="my-0 fs-16 text-black font-w600">Due Date</p>
                                        <small class="fs-16">{{data.dueDate| date: 'MM/dd/yyyy'}}</small>
                                    </div>
                                    <!-- <span class="text-muted ">{{data.currency| currencySymbol}}{{data.amount | number}}</span> -->
                                    <div>
                                        <p class="my-0 fs-16 text-black font-w600">Balance Due</p>
                                        <small class="fs-16">{{data.currency| currencySymbol}}{{data.pending_amount | number : '1.2-2'}}</small>
                                    </div>
                                </li>
                                <li *ngIf="selectedPaymentMethod" class="list-group-item d-flex justify-content-between">
                                    <div style="padding-top: 5px;">
                                        <span class="ac-totalblock fs-16 text-black font-w600">Service Fee</span>
                                    </div>
                                    <div class="serviceFee">${{serviceFee}} </div>
                                 </li>
                                <li class="list-group-item d-flex justify-content-between">
                                    <div style="padding-top: 5px;">
                                        <span class="ac-totalblock fs-16 text-black font-w600">Total Amount to Pay ($)</span>
                                    </div>
                                    <div>
                                        <input type="text"  [value] = "amount | number : '1.2-2'" disabled="true" class="inputbox form-control" style="text-align: right;font-weight: 600; width: 110px;background-color: #fff; border: none;padding-top: 2px;">
                                    </div>
                                 </li>
                            </ul>
                            <ul class="list-group mb-3" *ngIf="historicalInvoicePymtIndicator">
                                <li class="list-group-item d-flex justify-content-between">
                                    <!-- <div style="padding-top: 5px;"><span class="ac-totalblock fs-16 text-black font-w600">Paying towards BAN</span>
                                    </div>
                                    <div> <input type="text" [value]="ban" disabled="true" class="inputbox form-control"
                                            style="text-align: right;font-weight: 600; width: 110px;background-color: #fff; border: none;padding-top: 2px;">
                                    </div> -->
                                    <div style="padding-top: 5px;">
                                        <span class="ac-totalblock fs-16 text-black font-w600">BAN</span>
                                    </div>
                                    <div>
                                        <input type="text" [value]="ban" disabled="true" class="inputbox form-control" style="text-align: right;font-weight: 600; background-color: #fff; border: none;padding-top: 2px;">
                                    </div>
                                </li>
                                <li *ngIf="selectedPaymentMethod" class="list-group-item d-flex justify-content-between">
                                    <div style="padding-top: 5px;">
                                        <span class="ac-totalblock fs-16 text-black font-w600">Service Fee</span>
                                    </div>
                                    <div class="serviceFee">${{serviceFee}} </div>
                                 </li>
                                <li class="list-group-item d-flex justify-content-between">
                                    <div style="padding-top: 5px;">
                                        <span class="ac-totalblock fs-16 text-black font-w600">Total Amount to Pay ($)</span>
                                    </div>
                                    <div>
                                        <input type="text" [value]="amount | number : '1.2-2'" disabled="true" class="inputbox form-control" style="text-align: right;font-weight: 600; width: 110px;background-color: #fff; border: none;padding-top: 2px;">
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
